import { animate } from "dauphine-js/src/utils";

const settings = {
    bannerSelector: "[js-banner]",
    closeSelector: "[js-banner-close]",
    animations: {
        slideUp: 'slide-up',
        slideDown: 'slide-down',
    },
    breakpoints: {
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px'
    },
    getMediaQuery: breakpoint => `(min-width: ${breakpoint})`,
    dynamicResizing: true
}


const banners = document.querySelectorAll(settings.bannerSelector);
const closeButtons = document.querySelectorAll(settings.closeSelector);
let animation = window.matchMedia(settings.getMediaQuery(settings.breakpoints.sm)).matches ? settings.animations.slideUp : settings.animations.slideDown;

/**
 * Handle close button click
 */
closeButtons.forEach(el => {
    el.addEventListener('click', () => {
        banners.forEach(banner => {
            animate(banner, animation, () => {
            }, true);
        })
    })
});

/**
 * Handle window resizing
 * Change animation type
 */
if (settings.dynamicResizing) {
    window.addEventListener('resize', () => {
        animation = window.matchMedia(settings.getMediaQuery(settings.breakpoints.md)).matches ? settings.animations.slideUp : settings.animations.slideDown;
    });
}
